import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DvDynamicFormElement,
  DvDynamicFormModule,
  DvFormUtils,
  FormOf,
} from '@devinco/ui/legacy';
import { TimeInterval } from '@features/trip-type-setup/interfaces';
import { TripTypeSetupDialogFormService } from './trip-type-setup-dialog-form.service';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '@shared/pipes/pipes.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';

@Component({
  selector: 'app-trip-type-setup-dialog',
  templateUrl: './trip-type-setup-dialog.component.html',
  imports: [
    CommonModule,
    PipesModule,
    DvDynamicFormModule,
    DvDialogContentComponent,
    DvButtonComponent,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [TripTypeSetupDialogFormService],
})
export class TripTypeSetupDialogComponent
  extends DvDialogContent<
    TimeInterval | undefined,
    TripTypeSetupDialogComponent
  >
  implements OnInit
{
  private formService = inject(TripTypeSetupDialogFormService);

  timeFormGroup: FormGroup<FormOf<Pick<TimeInterval, 'From' | 'To'>>>;
  weekdaysFormGroup: FormGroup<FormOf<Partial<TimeInterval>>>;

  timeElements: DvDynamicFormElement[];
  weekdaysElements: DvDynamicFormElement[];

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.timeElements = this.formService.timeElements;
    this.timeFormGroup = DvFormUtils.createFormGroup(this.timeElements);

    this.weekdaysElements = this.formService.weekElements;
    this.weekdaysFormGroup = DvFormUtils.createFormGroup(this.weekdaysElements);

    this.setFormData();
    this.setupEvents();
  }

  performSave(): void {
    this.dialogRef.onConfirm({
      ...this.data,
      ...this.timeFormGroup.value,
      ...this.weekdaysFormGroup.value,
    });
  }

  cancel(): void {
    this.dialogRef.onClose();
  }

  private setFormData(): void {
    if (this.data) {
      this.timeFormGroup.patchValue(this.data);
      this.weekdaysFormGroup.patchValue(this.data);
    }
  }

  private setupEvents(): void {
    this.timeFormGroup.controls.To.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe(_ => {
        this.timeFormGroup.controls.From.markAsDirty();
        this.timeFormGroup.controls.From.updateValueAndValidity();
      });
  }
}
